/* eslint-env browser */

const lightbox = document.querySelector('.lightbox')
const backPopup = document.querySelector('.back-popup')
const popup = backPopup.querySelector('.popup')
const popupBtnDownload = popup.querySelector('#download')
const popupBtnCancel = popup.querySelector('#cancel')
const popupLicense = popup.querySelector('p > a')

let license

const downloadOpen = (e = window.event) => {
  fastdom.measure(() => {
    const light = document.querySelector('.light')
    const href = e.target.getAttribute('data-href')
    if (!license) license = popupLicense.getAttribute('data-href')
    fastdom.mutate(() => {
      if (!light) {
        noScroll()
      }
      backPopup.classList.add('--ativo')
      popup.classList.add('--ativo')

      popupLicense.setAttribute('href', license)
      popupBtnDownload.setAttribute('href', href)
    })
  })
}

const downloadKill = () => {
  fastdom.measure(() => {
    const light = document.querySelector('.light')
    const isOpen = popup.classList.contains('--ativo')
    fastdom.mutate(() => {
      if (isOpen) {
        if (!light) {
          noScroll()
        }
        backPopup.classList.remove('--ativo')
        popup.classList.remove('--ativo')

        popupBtnDownload.removeAttribute('href')
        popupLicense.removeAttribute('href')
      }
    })
  })
}

const downloadClose = (e = window.event) => {
  const {
    target,
  } = e
  e.stopImmediatePropagation()
  if (target !== backPopup && target !== popupBtnCancel && target !== popupBtnDownload) return null
  downloadKill()
  return true
}

window.addEventListener('resize', downloadKill, false)
